import type { PropsWithChildren } from 'react';
import { createRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import './css-transition-items.css';

interface Props {
    items: Array<any>;
    activeItem: number;
    type: 'fade' | 'translateX' | 'translateY';
    className?: string;
}

export const CssTransitionItems: FC<PropsWithChildren<Props>> = ({ items, children, activeItem, type, className }) => {
    const refs = items.map(() => ({ nodeRef: createRef() as RefObject<HTMLDivElement> }));
    // FRONT-2AEG: items может быть пустым (новый вопрос ещё без вариантов),
    // поэтому refs[activeItem] может отсутствовать — берём запасной ref.
    const nodeRef = refs[activeItem]?.nodeRef ?? createRef<HTMLDivElement>();

    return (
        <SwitchTransition mode='out-in'>
            <CSSTransition
                key={activeItem}
                nodeRef={nodeRef}
                addEndListener={(done) => {
                    nodeRef.current?.addEventListener('transitionend', done, false);
                }}
                classNames={type}
            >
                <div className={className} ref={nodeRef}>
                    {children}
                </div>
            </CSSTransition>
        </SwitchTransition>
    );
};
